import { CurrencyEnum } from './currency.type'
import { ProfileProps } from './profiles.type'
import { SupplyOrderProps, SupplyStatementProps } from './supplier-order.type'
import { SupplierProps } from './supplier.type'

export enum SupplyTransactionStatusEnum {
  'pending' = 'pending',
  'paid' = 'paid',
  'cancelled' = 'cancelled',
}

export interface SupplyTransactionProps {
  uuid?: string
  status: keyof typeof SupplyTransactionStatusEnum
  value: string
  currency: keyof typeof CurrencyEnum
  reference?: string
  supplier: SupplierProps
  supplyOrders: SupplyOrderProps[]
  destinationBank: string
  paymentAt?: string
  expectedPaymentDate?: string
  proofFile: string
  additionalProofFile?: string
  dollarExchangeRate?: string
  buyer?: ProfileProps
  saleOrders?: {
    uuid: string
    reference: string
  }[]
  supplyStatements?: SupplyStatementProps[]
  isRefunded?: boolean
  createdAt?: string
  updatedAt?: string
}

export interface SupplyTransactionWithPagesProps {
  count: number
  next?: string
  previous?: string
  results?: SupplyTransactionProps[]
}

export interface SupplyTransactionCreatePayload {
  supplyOrders: string[]
}
